export class DiversityTemplateConstants {
}
DiversityTemplateConstants.ReservedColumnNames = [
    'Gender',
    'DaysSinceHire',
    'DaysSinceTermination',
    'Hired',
    'Attrition',
    'Count'
];
DiversityTemplateConstants.HiringByEthnicity = 'Hiring by Ethnicity';
DiversityTemplateConstants.AttritionByEthnicity = 'Attrition by Ethnicity';
DiversityTemplateConstants.DiversityMeasure = 'Diversity Measure';
DiversityTemplateConstants.JobGroupEthnicity = 'Job Group Ethnicity';
DiversityTemplateConstants.DiversityOverTime = 'Diversity Over Time';
DiversityTemplateConstants.OtherValue = `Other`;
DiversityTemplateConstants.EthnicityOutput = 'Ethnic Makeup';
DiversityTemplateConstants.EthnicityEthnicityColumn = 'Ethnicity';
DiversityTemplateConstants.EthnicityCountColumn = 'Count';
DiversityTemplateConstants.GenderByEthnicityOutput = 'Gender by Ethnicity';
DiversityTemplateConstants.GenderEthnicityColumn = 'Ethnicity';
DiversityTemplateConstants.GenderColumn = 'Gender';
DiversityTemplateConstants.GenderCountColumn = 'Count';
DiversityTemplateConstants.GenderOtherValue = 'other';
DiversityTemplateConstants.GenderCountOutput = 'Gender Count';
DiversityTemplateConstants.GenderCountCountColumn = 'Count';
DiversityTemplateConstants.GenderCountGenderColumn = 'Gender';
DiversityTemplateConstants.GenderCountEthnicityColumn = 'Ethnicity';
DiversityTemplateConstants.GenderCountIsExecutiveColumn = 'IsExecutive';
// Keep IDs
DiversityTemplateConstants.EmployeeDataElementID = 'nBbnR5pzUiT0FA';
DiversityTemplateConstants.EmployeeRenameInputColumnsElementID = 'i_uDb4P-UC0M5Q';
DiversityTemplateConstants.EmployeeGenderCaseElementID = 'oxNBd73WpVTV3w';
DiversityTemplateConstants.EmployeeSeniorityConditionalElementID = 'u4JWk4lZOlQ7hA';
DiversityTemplateConstants.ApplicationDataElementID = '0pS0kSp8vIJ4HA';
DiversityTemplateConstants.ApplicationRenameInputColumnsElementID = 'yziL8lu85wAhsg';
DiversityTemplateConstants.ApplicationSeniorityConditionalElementID = 'nuO7a1AaM0UTMQ';
DiversityTemplateConstants.ApplicationHiredConditionalElementID = 'siTuSPe4v6rKOQ';
// Other IDs
DiversityTemplateConstants.RecordIDMonths = 'ZtSwpfyTThGY_g';
DiversityTemplateConstants.RepeatMonths = '7kR5ZD2bNylRRQ';
DiversityTemplateConstants.FilterOldEmployees = 'D2bfXRvKdtszbQ';
DiversityTemplateConstants.FilterOldApplicants = 'f9bUWRcn3FPKnw';
//# sourceMappingURL=diversityTemplateConstants.js.map